import { Controller } from '@hotwired/stimulus';

// A direct fragment link moves keyboard focus to its target after the browser scrolls it, so the
// focused section does not disappear above the sticky header. Deep links still work without JS.
export default class extends Controller {
  connect() {
    this.focusCurrentTarget();
  }

  focusCurrentTarget() {
    if (window.location.hash) this.focusTarget(window.location.hash);
  }

  focusTarget(hash) {
    let targetId;
    try {
      targetId = decodeURIComponent(hash.slice(1));
    } catch {
      return;
    }

    const target = document.getElementById(targetId);
    if (!target) return;

    requestAnimationFrame(() => target.focus({ preventScroll: true }));
  }
}
